var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBox = function SvgBox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.601 7.874a.75.75 0 0 1 1.025-.273l8.454 4.892 8.394-4.862a.75.75 0 1 1 .752 1.298l-8.77 5.08a.75.75 0 0 1-.752 0L2.874 8.9a.75.75 0 0 1-.273-1.025Z",
    fill: "#123862"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.05 12.5a.75.75 0 0 1 .75.75v9.07a.75.75 0 0 1-1.5 0v-9.07a.75.75 0 0 1 .75-.75Z",
    fill: "#123862"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.995 23.49c-.89 0-1.771-.195-2.47-.583l-5.404-3.039C2.654 19.05 1.5 17.076 1.5 15.378v-5.78c0-1.699 1.154-3.663 2.621-4.492l5.415-3.018c1.376-.777 3.542-.787 4.939-.01l5.404 3.038c1.467.819 2.621 2.793 2.621 4.491v5.78c0 1.699-1.154 3.663-2.621 4.491l-5.405 3.039c-.688.389-1.578.583-2.469.583l-.01-.01Zm0-20.45c-.638 0-1.275.133-1.74.388L4.85 6.457c-.982.552-1.832 2.015-1.832 3.14v5.78c0 1.126.86 2.599 1.832 3.14l5.404 3.04c.921.51 2.54.51 3.461 0l5.405-3.04c.981-.552 1.832-2.014 1.832-3.15v-5.78c0-1.125-.86-2.598-1.832-3.14l-5.405-3.039c-.465-.256-1.093-.379-1.72-.379v.01Z",
    fill: "#123862"
  })));
};
export default SvgBox;